module.exports = __webpack_public_path__ + "static/og-3f1e98e237a9301a975ad001ba026820.png";